import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import PlayerToSell from '../TeamSquad';
import TeamSquadPopups from '../../../../../TeamSquadPopups';
import {
  playerAccBoost,
  playerDelayDecline,
} from '../../../../../../redux/actions/Team';
import {
  isFilterShown,
  getSelectedPlayerByIndexInSearchable,
} from '../../../../../../redux/selector/Transfers';
import { playerFromList } from '../../../../../../redux/selector/Team';
import { dataForSidebar } from '../../../../../../redux/selector/Sidebar';

import { StyledTransfersSearch, StyledContainerForFilter } from './styled';

export default React.memo(function TransfersSearch() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isShortlist = location.pathname.includes('/shortlist');
  const isShownFilter = useSelector(isFilterShown);
  const playerWithOffer = useSelector(getSelectedPlayerByIndexInSearchable);
  const selectedPlayer = useSelector(playerFromList);
  const { cash } = useSelector(dataForSidebar);
  // Search players mounts TeamSquadPopups on the page; shortlist does not —
  // mount them here so Buy / Loan / Scout from the slide work.
  const showShortlistPopups = isShortlist && !isEmpty(selectedPlayer);

  return (
    <>
      <StyledTransfersSearch isShownFilter={isShownFilter}>
        <StyledContainerForFilter className="filter-container" />
      </StyledTransfersSearch>
      {!isShownFilter && (playerWithOffer || (isShortlist && selectedPlayer)) && (
        <PlayerToSell searchPage />
      )}
      {showShortlistPopups && (
        <TeamSquadPopups
          selectedPlayer={selectedPlayer}
          cash={cash}
          onDelayDecline={() => dispatch(playerDelayDecline(selectedPlayer._id))}
          onAccelerateDevelopment={() =>
            dispatch(playerAccBoost(selectedPlayer._id))
          }
        />
      )}
    </>
  );
});
